import {
    useMemo,
} from 'react'
import {
    Navigate,
} from 'react-router-dom'
import {
    SkyNetRouteConfigObject, useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ContactManagementDomains,
} from 'app/enums/domain.enums'
import useContactManagementRoutes from 'app/SkyNetRoutes/hooks/useContactManagementRoutes'
import Companies from './Companies'
import Locations from './Locations'
import BillingCompanies from './BillingCompanies'
import Contacts from './Contacts'
import Users from './Users'
import AirportsAndSeaports from './AirportsAndSeaports'
import Countries from './Countries'

export default function ContactManagement() {
    const Routes = useContactManagementRoutes()

    const routesConfig: SkyNetRouteConfigObject<ContactManagementDomains> = useMemo(() => {
        return {
            [Routes.Companies.route]: <Companies />,
            [Routes.Locations.route]: <Locations />,
            [Routes.BillingCompanies.route]: <BillingCompanies />,
            [Routes.AirportsAndSeaports.route]: <AirportsAndSeaports />,
            [Routes.Contacts.route]: <Contacts />,
            [Routes.Countries.route]: <Countries />,
            [Routes.Users.route]: <Users />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.Locations.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}
